import { gql } from "@apollo/client";

export const QUERY = gql`
  query getCompany($companySlug: String, $isUser: Boolean!) {
    company(slug: $companySlug) {
      id
      locations {
        address
        company {
          name
          slug
        }
        displayName
        games {
          isCompleted @include(if: $isUser)
          isSaved @include(if: $isUser)
          awards {
            id
            displayTitle
            category {
              source {
                awardName
                sourceName
              }
            }
          }
          communityRatingCount
          communityScoreBucket
          communityScorePercentages {
            percentage
            rating
          }
          gameimageSet {
            imageUrl
            imageId
            order
          }
          id
          minutes
          name
          overallRating
          playersMax
          playersMin
          primaryCategory {
            id
            name
            slug
            parent {
              id
              name
              slug
            }
          }
          secondaryCategories {
            id
            name
            slug
          }
          slug
          status
          url
          userReview {
            id
          }
        }
        id
        location {
          coordinates
        }
        phoneNumber
        slug
        url
      }
      name
      slug
      url
    }
  }
`;
